/**
 * The simulations' mark: what every one of them is — a curve that answers a
 * slider. A wave above, and the control that drives it below.
 *
 * Its own colours, like the benches' marks, so it reads the same in either
 * theme: the benches' blue for the response, their amber for the thing you move.
 */
export function SimulationsMark({ size = 26, className }: { size?: number; className?: string }): React.JSX.Element {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {/* the response */}
      <path d="M2 10 C4.5 3, 7 3, 9.5 10 S14.5 17, 17 10 S20.5 5, 22 7"
            fill="none" stroke="#3b9ae1" strokeWidth="1.8" strokeLinecap="round" />
      {/* the control that drives it */}
      <path d="M3 19.5 H21" stroke="#9fb4c8" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M3 19.5 H13" stroke="#f0a000" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="13" cy="19.5" r="2.3" fill="#f0a000" stroke="#fff" strokeOpacity="0.85" strokeWidth="0.8" />
    </svg>
  );
}
